import { Dispatch } from "redux";
import {
  DESENCRIPTA_URL_REQUEST,
  DESENCRIPTA_URL_SUCCESS,
  DESENCRIPTA_URL_FAIL,
} from "./types";
import axiosInstance from '../../../services/axiosConfig';


export const desencriptarURLActions = (datosPersona: string | null, token_aplicacion: string | null) => async (dispatch: Dispatch): Promise<string | null> => {

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  dispatch({ type: DESENCRIPTA_URL_REQUEST });

  try {
    const res = await axiosInstance.post(`${import.meta.env.VITE_CSRF_API_LOGIN}/desencriptarURLActions?datosPersona=${datosPersona}&token_aplicacion=${token_aplicacion}`, config);

    if (res.status === 200) {
      dispatch({
        type: DESENCRIPTA_URL_SUCCESS
      });
      return res.data;
    } else {
      dispatch({
        type: DESENCRIPTA_URL_FAIL,
        error:
          "No se pudo registrar los datos ingresados. Por favor, intente nuevamente.",
      });
      return null;
    }
  } catch (err: any) {
    dispatch({
      type: DESENCRIPTA_URL_FAIL,
      error: err?.message || "Error desconocido",
    });
    return null;
  }
};

